import { useTranslation } from "react-i18next";
import UsersProfileImage from "../../default_components/UsersProfileImage";
import { approvedThisMonth, loggedThisMonth } from "../lib/calculateLogData";
import PropTypes from "prop-types";

const User = ({ user, selectedUser, setSelectedUser, allUserLogs, date }) => {
  const { t } = useTranslation();

  const WorkingTimeInMonth = (user, date) => {
    if (user.custom_working_hours) return user.custom_working_hours;

    const firstDateOfMonth = date.startOf("month");
    let workingHoursInMonth = 0;

    for (let i = 0; i < date.endOf("month").day; i++) {
      const dateSchedule = user.schedule[firstDateOfMonth.plus({ day: i }).weekday % 7];

      workingHoursInMonth += dateSchedule[0] + dateSchedule[2];
    }

    return workingHoursInMonth / 60;
  };

  return (
    <div
      key={user.id}
      className={`column-user__form ${user.id === selectedUser.id ? " column-user__form_selected" : ""}`}
      onClick={() => setSelectedUser(user)}
    >
      <div className="column-user__avatar-block">
        <UsersProfileImage size={30} user={user} userImage={user.avatars["30"]} header={true} />
      </div>
      <div className="column-user__user-info">
        <p>
          {user.first_name} <br />
          {user.last_name}
        </p>
      </div>
      <div className="column-user__user-approval-hours">
        <p title={t("actuals.total_working_hours")}>{WorkingTimeInMonth(user, date)}h /&nbsp;</p>

        <p title={t("actuals.total_logged_hours")}>{loggedThisMonth(allUserLogs, date) || 0}h /&nbsp;</p>

        <p title={t("actuals.total_approved_hours")}>{approvedThisMonth(allUserLogs, date) || 0}h</p>
      </div>
    </div>
  );
};

User.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    custom_working_hours: PropTypes.number,
    schedule: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
    avatars: PropTypes.shape({
      30: PropTypes.string,
    }).isRequired,
  }).isRequired,
  selectedUser: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  allUserLogs: PropTypes.arrayOf(PropTypes.object).isRequired,
  date: PropTypes.shape({
    startOf: PropTypes.func.isRequired,
    endOf: PropTypes.func.isRequired,
    plus: PropTypes.func.isRequired,
    weekday: PropTypes.number.isRequired,
  }).isRequired,
};

export default User;
